import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
           click: {
                fontsize: 'fontsize',
                lineheight: 'lineheight',
                contrast: 'contrast',
                reset: 'reset',
            }
        }
        this.values ={
            fontsize : "",
            lineheight : "",
            contrast : ""
        }
        
    }

    init() {
        //console.log('Accessibility on');
    }

    fontsize(el) {
        this.setVariables(el,'font-size',16,'px');
    }
    lineheight(el) {
        this.setVariables(el,'line-height',1.15,'');
    }
    contrast(el) {
        this.setVariables(el,'contrast',100,'%');
    }

    setVariables(el,cssAttribute,defaultValue,suffix) {
        let target = el.currentTarget;
        let htmlStyle = getComputedStyle(document.querySelector("html"));
        let dataName = cssAttribute.replace('-','');
        let currentValue = htmlStyle.getPropertyValue('--html-'+cssAttribute);
        document.querySelector("html").classList.add('is-accessible-'+cssAttribute);
        if(currentValue == ""){
            currentValue = defaultValue+suffix;
        }else{
            if(htmlStyle.getPropertyValue('--html-'+cssAttribute)){
                currentValue = htmlStyle.getPropertyValue('--html-'+cssAttribute);
            }
        }
        currentValue = currentValue.replace(suffix,'');
        currentValue = parseFloat(currentValue,2) + parseFloat(target.getAttribute('data-'+dataName),2);
        this.values[dataName] = '--html-'+cssAttribute+':'+currentValue+suffix+' !important; ';
        let newCssDeclaration = "";
        for (const [property, value] of Object.entries(this.values)) {
            newCssDeclaration += value;
        }
        document.querySelector('#accessibility-vars').innerHTML = 'html{'+newCssDeclaration+'}';
    }

    reset() {
        document.querySelector("html").classList.remove('is-accessible-font-size,is-accessible-line-height,is-accessible-contrast');
        document.querySelector('#accessibility-vars').innerHTML = '';
        document.querySelector('.js-accessibility-nav').classList.remove('-theme-light');

        for (const [property, value] of Object.entries(this.values)) {
            this.values[property]="";
        }
    }
}
